<template>
    <v-layout align-center column>


<img src="../../assets/404/404-Illustration.png"
     srcset="../../assets/404/404-Illustration@2x.png 2x,
             ../../assets/404/404-Illustration@3x.png 3x"
     class="-Illustration">
 
    <p class="Page-Not-Found">Page Not Found</p>
    <p class="The-page-you-are-looking-for-might-have-been-remov">The page you are looking for might have been removed had it’s name changed or is temporarily unavailable.</p>
    <a href="/"><div class="Shape"> <p class="Shape-Text"> Go To Homepage</p></div></a>
    </v-layout>
</template>
<script>
export default {
    
}
</script>
<style scoped>
.-Illustration {
  width: 600px;
  height: 400px;
  flex-grow: 0;
  margin: 0 0 24px;
  object-fit: contain;
}
.Page-Not-Found {
  width: 198px;
  height: 30px;
  flex-grow: 0;
  margin: 24px 201px 16px;
  font-family: Sora;
  font-size: 24px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #d3352c;
}
.The-page-you-are-looking-for-might-have-been-remov {
  width: 450px;
  height: 44px;
  flex-grow: 0;
  margin: 16px 75px 44px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Shape {
  width: 225px;
  height: 48px;
  flex-grow: 0;
  padding: 15px 54px 16px;
  border-radius: 26px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  background-color: #252525;
}
.Shape-Text {
  width: 117px;
  height: 17px;
  flex-grow: 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}
</style>